// Internet Explorer 6-11
export const isIE =
    navigator.userAgent.indexOf('MSIE') > -1 || navigator.userAgent.indexOf('Trident') > -1;

export const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
